var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container button"},[_c('input',{class:{ disabled: _vm._disabled },style:({
      backgroundColor: _vm.color,
      width: _vm.width,
      borderRadius: _vm.borderRadius
    }),attrs:{"id":_vm.id,"type":"button","disabled":_vm._disabled,"value":_vm.label},on:{"click":_vm.validate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }